import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Modal, ModalBody, Button, Label, Form, Input, Col, Row} from 'reactstrap';
import {sharedLabelsPath} from '../../../../../reducers/common/localization';
import './DuePaymentsConfirmModal.css';
import {CURRENCIES} from '../../../../../constants/constants';

class DuePaymentsConfirmModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            amount: '',
            comment: ''
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.isOpen && this.props.isOpen !== nextProps.isOpen) {
            this.setState({ amount: '' });
        }

        if (nextProps.isOpen && this.props.isOpen !== nextProps.isOpen) {
            this.setState({ amount: nextProps.amount.amount });
        }
    }

    render() {
        if (!this.props.id || !this.props.amount) {
            return null;
        }

        return (
            <Modal isOpen={this.props.isOpen}>
                <ModalBody>
                    <Form onSubmit={this.handleSubmit}>
                        <h6>{this.renderLabel()}</h6>
                        <Row className="modal-form-field-container">
                            <Col sm={4} className="modal-label-container">
                                <Label>{_.get(this.props.translation, 'system_payment.amount_label') + '*'}</Label>
                            </Col>
                            <Col sm={7}>
                                <Input
                                    type="number"
                                    min={0}
                                    max={this.props.amount.amount}
                                    step="any"
                                    value={this.state.amount}
                                    onChange={this.handleChangeAmount}
                                    onBlur={this.handleBlur}
                                    onKeyDown={this.handleKeyDown}
                                    required
                                />
                            </Col>
                            <Col sm={1} className="due-payments-modal-currency-col">
                                <h6>{CURRENCIES[this.props.amount.currency]}</h6>
                            </Col>
                        </Row>
                        <Row className="modal-form-field-container">
                            <Col>
                                <Input type="textarea"
                                       value={this.state.comment}
                                       onChange={this.handleChangeComment}
                                       placeholder={_.get(this.props.translation, 'finance.balance_change_comment_placeholder')}
                                />
                            </Col>
                        </Row>
                        <div className="modal-buttons-container">
                            <Button color="secondary"
                                    onClick={this.props.onCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                            <Button className="olive-green-btn" type="submit"
                                    disabled={!this.state.amount || this.state.amount === ''}>
                                {_.get(this.props.translation, 'system_payment.paid_button')}
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        );
    }

    renderLabel = () => {
        if (this.props.name) {
            return _.get(this.props.translation, 'system_payment.due_payment_modal_label').replace('{name}', this.props.name);
        }
        return _.get(this.props.translation, this.props.label);
    }

    handleChangeComment = (e) => {
        this.setState({ comment: e.target.value })
    };

    handleChangeAmount = (e) => {
        this.setState({ amount: e.target.value });
    };

    handleBlur = () => {
        let newValue = Number(this.state.amount);

        if (Number(newValue) < 0) {
            newValue = 0;
        }

        this.setState({
            amount: newValue.toFixed(2)
        });
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        let data = {
            delta: {
                amount: this.state.amount,
                currency: this.props.amount.currency
            }
        };

        if (!_.isEmpty(this.state.comment)) {
            data.comment = this.state.comment;
        }

        this.props.onPayDuePayments(this.props.id, data);
    }
}

DuePaymentsConfirmModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    id: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    amount: PropTypes.object,
    translation: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onPayDuePayments: PropTypes.func.isRequired
};

export default DuePaymentsConfirmModal;



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/duePaymentsList/duePaymentsConfirmModal/DuePaymentsConfirmModal.js